import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { MODAL_TYPE_PDF_VIEW_IMAGE, showModal, } from '../../../../../actions/ModalActions';
import { noneStyle } from '../../../../../helpers/common';
import { propArrayShape } from '../../../../../helpers/custom-prop-types';
import CustomSlider from '../../../../Ui/Slider';
import AboutContentsPortfoliosItem from './AboutContentsPortfoliosItem';
const AboutContentsPortfolios = (props) => {
    const { portfolios } = props;
    const dispatch = useDispatch();
    const isSmall = useMediaQuery({ minWidth: 480 });
    const dataAttributes = {};
    const infiniteConfig = useMemo(() => ({
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToShow: 3,
        speed: 300,
    }), []);
    const config = useMemo(() => ({
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToShow: 3,
        speed: 300,
    }), []);
    const setFillCount = useMemo(() => Math.max((isSmall ? 0 : 3) - portfolios.length, 0), [isSmall, portfolios]);
    const fillItems = useMemo(() => [...Array(setFillCount)].map((_, index) => index), [setFillCount]);
    const showPdfModal = useCallback((images) => dispatch(showModal(MODAL_TYPE_PDF_VIEW_IMAGE, null, { images })), [dispatch]);
    return (_jsx("section", { children: _jsxs("div", Object.assign({ className: 'about-box is-free' }, { children: [_jsx("h2", Object.assign({ className: 'about-title' }, { children: "PORTFOLIO" })), _jsxs(CustomSlider, Object.assign({ className: 'solution-slider', config: portfolios.length > 3 ? infiniteConfig : config, dataAttributes: dataAttributes, wrapperClassName: 'about-slider slick-slider slide-container initialized', wrapperElement: 'div' }, { children: [portfolios.map((portfolio) => (_jsx(AboutContentsPortfoliosItem, { portfolio: portfolio, showPdfModal: showPdfModal }, portfolio.id))), fillItems.map((v) => (_jsx("li", { style: noneStyle }, v)))] }))] })) }));
};
AboutContentsPortfolios.propTypes = {
    portfolios: propArrayShape().isRequired,
};
export default AboutContentsPortfolios;
